module.exports = __webpack_public_path__ + "img/global-business-vision.e90c2f50.webp";